import { HeliosDataProvider } from 'providers/admin/dataProvider';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';
import { useMutation } from 'react-query';
import { ActionMutationReturn } from 'types/common.types';
import { UploadFileBody } from 'types/customMethods.types';

export const useUploadDocument = (): ActionMutationReturn<
  unknown,
  unknown,
  { customerId: string; data: UploadFileBody },
  unknown
> => {
  const refresh = useRefresh();
  const dataProvider = useDataProvider<HeliosDataProvider>();
  const notify = useNotify();

  return useMutation(
    ['uploadDocument', dataProvider],
    (params: { customerId: string; data: UploadFileBody }) => {
      return dataProvider
        .uploadDocument(params.customerId, params.data)
        .then((response: unknown) => {
          if (response) {
            refresh();
            notify('customer.actions.addDocumentModal.upload.success', {
              type: 'success',
            });
          }
        })
        .catch(() => {
          notify('customer.actions.addDocumentModal.upload.error', {
            type: 'error',
          });
        });
    }
  );
};
